import MD5 from 'crypto-js/md5';
import SHA512 from 'crypto-js/sha512';
import moment from 'moment-timezone';
import numbro from 'numbro';
import xss from 'xss';
import Cookies from 'js-cookie';
import { getAnalytics, logEvent } from 'firebase/analytics';
import _isNil from 'lodash-es/isNil';
import qs from 'qs';

// import Vue from 'vue'
import { PwdValidateEnum, OLD_LOCALES_OBJ_REVERSE } from './const';
import { COOKIE_NAME, setLoginInfoInApp } from '~/frontend-shared/helper/login-util';
import { useI18n } from "vue-i18n";

export const getFiatName = (locale) => {
  return langToCoinName[locale] || 'USD';
};

// 语言和币种的映射,这里直接取 vuex 中locale的值避免多一道转换
export const langToCoin = {
  cn: 'CNY',
  en: 'USD',
  jp: 'JPY',
  kr: 'USD',
  vn: 'USD',
  ru: 'RUB',
  'zh-TW': 'HKD',
  tr: 'TRY',
  es: 'USD',
  br: 'USD',
};

export const ZENDESK_LANG_MAP = new Map([
  ['cn', 'zh-cn'],
  ['zh-TW', 'zh-tw'],
  ['en', 'en-us'],
  ['es', 'es'],
  ['jp', 'ja'],
  ['br', 'pt'],
  ['tr', 'tr'],
  ['vn', 'vi'],
  ['ru', 'ru'],
]);

// 正常转化
export const transLang = (lang, indexStore) => {
  console.log('indexStore?.localeConfigList >>>', indexStore?.localeConfigList);
  const localeConfigList = indexStore?.localeConfigList;
  const currLocaleInfo = localeConfigList?.find((item) => item.locale === lang);
  // 这里只保留小写的映射
  if (I18nDict.has(lang)) {
    return I18nDict.get(lang);
  } else {
    return currLocaleInfo?.localeWithUnderLine || 'en_US';
  }
};
// 变态转化
export const transLang2 = (lang) => {
  let langParam = 'en';
  if (lang === 'cn') {
    langParam = 'zh-cn';
  }
  return langParam;
};

/**
 * @author hank.lv
 * @description 产生随机字符串
 * @param {string} prefix 前缀
 * @param {number} length 字符串长度(默认长度 10 )
 * @param {function}  process 对产生的字符串二次处理
 * @return {string} 随机字符串
 */
export const getRandomStr = (length = 6, prefix = '', process) => {
  // 由于 JS 的 Number.MAX_SAFE_INTEGER 转换为32位数也就是十一位 故超出11位要另外处理
  const getStr = (l) => (Math.random() * 32 ** l).toString(32).substring(0, length - 1);
  let str = '';
  for (let i = 0; i < Math.ceil(length / 11); i++) {
    str += length - 1 === i ? getStr(length % 11) : getStr(11);
  }
  return process ? process(str) : prefix + str;
};

// FIXME: 递归比较占用内存空间，建议采用尾递归优化，随机字符串可以采用 Math.random().toString(32).slice(2)
/**
 * @deprecated
 */
export const rand = (length, current) => {
  current = current ? current : '';
  return length
    ? rand(
      --length,
      '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.charAt(Math.floor(Math.random() * 60)) + current
    )
    : current;
};
/**
 *
 */
export const insertSignToParams = (params, timestamp, salt) => {
  const sortKeys = Object.keys(params).sort();
  const signArray = sortKeys.reduce((prev, key) => {
    let value = params[key];
    if (key !== 'timestamp' && value !== null && value !== undefined && value !== '') {
      return prev.concat(`${key}=${value}`);
    }
    return prev;
  }, []);
  const sign = MD5(signArray.join('&') + `${timestamp}${salt}`).toString();
  Object.assign(params, {
    sign,
  });
  return sign;
};
/**
 *
 */
export const insertSignToJSON = (params, timestamp, salt) => {
  const obj = {};
  Object.keys(params).forEach(function (key) {
    if (key !== 'timestamp') {
      obj[key] = params[key];
    }
  });
  const sign = SHA512(JSON.stringify(obj) + `${timestamp}${salt}`).toString();
  Object.assign(params, {
    sign,
  });
  return sign;
};

export const getSignByQueryString = (queryString, timestamp, salt) => {
  return MD5(`${queryString}${timestamp}${salt}`).toString();
};

/**
 * 注意，此对比需要数组首先排好序。
 * 后端深度图和其他数据基本都是按照一定规则排好序的，所以不要紧
 * 此函数没有返回值，直接对Vue中需要变化的数组进行插入（替代）操作
 * 不要拿空数组比较，对比数组长度应该长度一样
 */
export const compareArray = (oriArr, newArr, equalFn) => {
  const oriRMArr = []; // 需要从oriArr删除的数组下标 [2，3，6 ...]
  const newInsertArr = []; // 需要往oriArr添加的newArr数组下标 [2，3，6 ...]
  oriArr.forEach((oriItem, oriIndex) => {
    let ret = newArr.find((newItem) => {
      return equalFn(newItem, oriItem);
    });
    // 没有找到, 这个项应该从oriArr删除
    if (!ret) {
      oriRMArr.push(oriIndex);
    }
  });
  newArr.forEach((newItem, newIndex) => {
    let ret = oriArr.find((oriItem) => {
      return equalFn(newItem, oriItem);
    });
    // 没有找到, 这个项应该新增到oriArr
    if (!ret) {
      newInsertArr.push(newIndex);
    }
  });
  oriRMArr.forEach((rmIndex, index) => {
    // 有多少要删除的，就有多少要插入的。逻辑没问题
    // oriArr.splice(rmIndex, 1)
    oriArr.splice(rmIndex, 1, newArr[newInsertArr[index]]);
  });
};

//替换返回报文里含%s和%d
export const DeCodeRep = (res) => {
  if (res.msg === undefined) {
    res.msg = 'Unknown error';
  } else {
    if (res.msg.indexOf('%s') > -1) {
      res.msg = res.msg.replace(/%s/, res.data.limitMsg);
    } else if (res.msg.indexOf('%d') > -1) {
      res.msg = res.msg.replace(/%d/, res.data.limitCount);
    }
  }
  return res.msg;
};

// 对输入框输入数字做格式处理，并返回正确内容
export const filterNAN = (str) => {
  //得到第一个字符是否为负号
  let s = str.toString();
  let t = s.charAt(0);
  //先把非数字的都替换掉，除了数字和.
  s = s.replace(/[^\d.]/g, '');
  //必须保证第一个为数字而不是.
  s = s.replace(/^\./g, '');
  //保证只有出现一个.而没有多个.
  s = s.replace(/\.{2,}/g, '.');
  //保证.只出现一次，而不能出现两次以上
  s = s.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  //如果第一位是负号，则允许添加
  if (t == '-') {
    s = '-' + s;
  }
  return s;
};

export function filterPrecision(precision, count) {
  const segment = count.toString().split('.');
  if (segment.length === 1) {
    // 只有整数部分
    return count;
  }
  const [int, float] = segment;
  if (precision === 0) {
    // 数量精度有可能为0，所以阻止输入小数点
    return int;
  }
  if (!precision) {
    return count;
  }
  return [int, float.slice(0, precision)].join('.');
}

// 判断是否符合金融格式 只能有一位小数点， 小数点后最长30位， 仅包含数字和一个小数点
export const isMoneyType = (str) => {
  let s = str.toString();
  let reg = /^(([1-9]\d*|0)(\.\d{1,30})?)$|(0\.0?([1-9]\d?))$/;
  return reg.test(s);
};

// // 只影响注册 8-32  必须包括数字 英文
// export const validateRegPwd = (str) => {
//   let ret = /[a-zA-Z[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]+/.test(str) && /\d+/.test(str) && str.length >= 8 &&
//     str.length <= 32 && !(/\s/.test(str))
//   return ret
// }

//
export const validatePwd = (str) => {
  let ret =
    /[a-zA-Z[`~!@#$%^&*()_+<>?:"{},./;'[\]]+/.test(str) &&
    /\d+/.test(str) &&
    str.length >= 6 &&
    str.length <= 32 &&
    !/\s/.test(str);
  return ret;
};

export const getBrowserLang = () => {
  const lang = window.navigator.language;
  let locale;
  if (lang === 'zh-CN' || lang === 'cn' || lang === 'zh') {
    locale = 'cn';
  } else if (lang === 'vi-VN') {
    locale = 'vn';
  } else if (lang === 'ja-JP') {
    locale = 'jp';
  } else if (lang === 'ko-KR') {
    locale = 'kr';
  } else if (lang === 'ru-RU') {
    locale = 'ru';
  } else if (lang === 'zh-TW') {
    locale = 'zh-TW';
  } else if (lang === 'tr-TR') {
    locale = 'tr';
  } else {
    locale = 'en';
  }
  return locale;
};

/**
 *  倒计时方法
 * @param  {[type]}   timeCount [60s 传 number 60]
 * @param  {Function} cb        [description]
 * @return {[type]}             [description]
 */
export const countDown = (timeCount, cb) => {
  let intCount = setInterval(() => {
    if (timeCount === 0) {
      clearInterval(intCount);
      cb(0);
    } else {
      cb(timeCount--);
    }
  }, 1000);
};

export const breakDownHostUrl = (url) => {
  let hostUrl = url;
  let newUrl = hostUrl;
  // 防止未做301跳转，产生XXX.XXX的域名
  if (hostUrl.split('.') && hostUrl.split('.').length <= 2) {
    newUrl = hostUrl;
  } else {
    let number = hostUrl.indexOf('.');
    newUrl = hostUrl.slice(number + 1);
  }
  return newUrl;
};

// export const symbolListCompatibleHelper = state => {
//   if (process.env?.NODE_ENV === 'development') {
//     console.warn('Deprecate: use new symbolList structure for better performance')
//   }
//   const { symbolList, symbolById } = state.trade
//   if (!Array.isArray(symbolList)) return symbolList
//   console.time('symbolListCompatibleHelper')
//   const res = symbolList.map(d => {
//     return Object.assign({}, d, {
//       mappingList: Array.isArray(d.mappingIds) ? d.mappingIds.map(id => symbolById[id]) : []
//     })
//   })
//   console.timeEnd('symbolListCompatibleHelper')
//   console.log(res)
//   return res;
// }

// 密码加密
export const encryptPassword = (password) => SHA512(MD5(password).toString()).toString();

/**
 * K线在用，header也在用
 */
export const getTradingViewTimezone = () => {
  // https://caniuse.com/internationalization
  // https://momentjs.com/timezone/docs/#/using-timezones/guessing-user-timezone/
  if (Intl && Intl.DateTimeFormat) {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else {
    return moment.tz.guess();
  }
};

export const isLoginedToken = () => {
  if (!Cookies.get(COOKIE_NAME.SALT) || !Cookies.get(COOKIE_NAME.SALT)?.length || Cookies.get(COOKIE_NAME.SALT) === 'undefined' || Cookies.get(COOKIE_NAME.SALT) === 'null') {
    return false;
  } else {
    return true;
  }
};

export const simpleClientToLogin = ()=>{
  const route = useRoute();
  let locale = route.params.lang;
  if(!locale){
    locale = useIndexStore().normalizedLocaleWithCenterLine;
  }
  const query = qs.stringify({
    goto: route.name,
    others: JSON.stringify(route.query),
  });
  window.location.href = `/login/${locale}?${query}`;
  // console.log('query: ', `/login/${locale}?${query}`);
  // router.push(`/login/${locale}?${query}`);
}

export const gotoLogin = (router, route, locale, others, otherQuery = {}, exLogin) => {
  if (route.name === 'login-lang') {
    return;
  }
  const routeParam = {
    name: exLogin ? exLogin : 'login-lang',
    params: {
      lang: locale || 'en-US',
    },
    query: {
      goto: route.name,
      ...otherQuery,
    },
  };

  if (others) {
    routeParam.query.others = JSON.stringify(others);
  }

  router.push(routeParam);
};

/**
 * 计算密码强度分数
 * @param {string} pwdstring 密码字符串
 * @errorDetail {boolean} errorDetail 是否返回具体错误信息
 * @returns score 强度分数
 */
export const checkPwdScore = (pwdstring, errorDetail = false) => {
  // 检查长度
  const checkLength = (pwdstring) => {
    if (pwdstring.length <= 4) {
      return 5;
    }
    if (pwdstring.length <= 7 && pwdstring.length >= 5) {
      return 10;
    }
    return 25;
  };

  // 检查字母
  const checkLeters = (pwdstring, returnDetail) => {
    const hasBigLeters = pwdstring.match(/[A-Z]/);
    const hasSmallLeters = pwdstring.match(/[a-z]/);
    if (returnDetail) {
      return {
        [PwdValidateEnum.AtLess1UppercaseLetter]: !!hasBigLeters,
        [PwdValidateEnum.AtLess1LowercaseLetter]: !!hasSmallLeters,
      };
    }
    if (hasBigLeters && hasSmallLeters) {
      return 20;
    }
    if (hasBigLeters || hasSmallLeters) {
      return 10;
    }
    return 0;
  };

  // 检查数字
  const checkNumber = (pwdstring) => {
    const count = pwdstring.split('').filter((v) => /\d/.test(v)).length;
    if (count >= 3) {
      return 20;
    }
    if (count >= 1) {
      return 10;
    }
    return 0;
  };

  // 检查符号
  const checkSymbol = (pwdstring) => {
    const count = pwdstring.split('').filter((v) => /[\W|_]/.test(v)).length;
    if (count > 1) {
      return 25;
    }
    if (count === 1) {
      return 10;
    }
    return 0;
  };

  // 奖励
  const reward = (letersScore, numberScore, symbolScore) => {
    // 大小写字母、数字和符号
    if (letersScore == 20 && numberScore > 0 && symbolScore > 0) {
      return 5;
    }
    // 字母、数字和符号
    if (letersScore > 0 && numberScore > 0 && symbolScore > 0) {
      return 3;
    }
    // 字母和数字
    if (letersScore > 0 && numberScore > 0) {
      return 2;
    }
    return 0;
  };

  if (errorDetail) {
    // 需要返回详细的错误信息
    let lengthScore = checkLength(pwdstring);
    let letersDetail = checkLeters(pwdstring, errorDetail);
    let numberScore = checkNumber(pwdstring);
    let symbolScore = checkSymbol(pwdstring);
    return {
      [PwdValidateEnum.AtLess8Char]: lengthScore === 25,
      [PwdValidateEnum.AtLess1Numer]: numberScore > 0,
      [PwdValidateEnum.AtLess1Symbol]: symbolScore > 0,
      ...letersDetail,
    };
  }
  let lengthScore = checkLength(pwdstring);
  let letersScore = checkLeters(pwdstring);
  let numberScore = checkNumber(pwdstring);
  let symbolScore = checkSymbol(pwdstring);

  return {
    score: lengthScore + letersScore + numberScore + symbolScore + reward(letersScore, numberScore, symbolScore),
    info: {
      lengthScore,
      letersScore,
      numberScore,
      symbolScore,
    },
  };
};

/**
 * 检查密码强度
 * @param {string} pwdstring 密码字符串
 * @returns level 强度等级
 */
export const checkPwdLevel = (pwdstring) => {
  const { score } = checkPwdScore(pwdstring);
  if (score < 60) {
    return 'UNSAFE';
  }
  if (score > 80) {
    return 'SAFE';
  }
  return 'NORMAL';
};

/**
 * 校验注册/重置密码是否通过
 * @param {string} pwdstring 密码字符串
 * @returns boolean
 */
export const validateRegPwd = (pwdstring = '', errorDetail) => {
  if (errorDetail) {
    return checkPwdScore(pwdstring, errorDetail);
  }
  const { info } = checkPwdScore(pwdstring);
  if (info.lengthScore != 25) {
    return false;
  }
  if (info.numberScore > 0 && info.symbolScore > 0) {
    return true;
  }
  if (info.letersScore === 20) {
    return true;
  }
  if (info.letersScore === 10 && info.numberScore > 0) {
    return true;
  }
  if (info.letersScore === 10 && info.symbolScore > 0) {
    return true;
  }
  return false;
};

// 获取某个DOM相对于页面左上角的坐标,接收一个DOM对象
export function getCoordToPage(dom) {
  let parentDom = dom;
  let x = 0;
  let y = 0;
  while (parentDom) {
    x += parentDom.offsetLeft;
    y += parentDom.offsetTop;
    parentDom = parentDom.offsetParent;
  }
  return {
    x,
    y,
  };
}

// 用于处理小数精度问题,给出一个最大精度,如果小于这个精度不会补0 大于这个精度则按照最大精度来
export function maxPrecision(v, maxMantissa) {
  // 先过滤null undefined NaN 的情况
  if (v === null || v == undefined || Number.isNaN(v)) return v;
  // 传入的数字只有两种可能,数字和字符串
  let numStr = typeof v === 'string' ? v : v.toString(); // 先转换成字符串
  // 得到小数位数
  let arr = numStr.split('.');
  if (arr.length !== 2 || arr[1].length < maxMantissa) {
    // 说明是整数或者精度本身币最大精度小,其他的错误情况也一律直接返回,外部的问题交给外部处理
    return v;
  }

  return arr[0] + '.' + arr[1].slice(0, maxMantissa);
}

// 过滤掉假值
export function filterFalsityParams(params, needSign = false) {
  const dealdParams = Object.keys(params).reduce((map, key) => {
    if ([null, undefined, ''].indexOf(params[key]) !== -1) return map;
    else {
      map[key] = params[key];
      return map;
    }
  }, {});

  if (needSign) {
    const salt = Cookies.get('accessSalt');
    const timestamp = new Date().getTime(); // 当接口需要验签时，需要有timestamp，并调用以下如果这是一个

    return {
      ...dealdParams,
      timestamp,
      sign: insertSignToParams({ ...dealdParams, timestamp }, timestamp, salt),
    };
  } else {
    return dealdParams;
  }
}

// 表单输入时，仅支持数字
export function inputNumber(val, max, limit = 8) {
  if (_isNil(val) || Number.isNaN(Number(max))) return val;

  val = String(val);
  val = scientificNumber(val);
  // 过滤非数值的值
  val = val.replace(/[^0-9.]/g, '');

  // 过滤多出的小数点
  val = val.replace(/(\.[^.]*)(\.)?(.*)/, '$1');

  // 过滤小数点后的位数
  const reg = new RegExp(`(\\..{0,${limit}}).*`);
  val = val.replace(reg, '$1');

  return !_isNil(max) && Number(val) > Number(max) ? String(max) : String(val);
}

/**
 * @description 科学计数法转为string
 * @param {string, number} param
 */
export function scientificNumber(param) {
  let strParam = String(param);
  // 是否含有科学计数
  let flag = /e/.test(strParam);
  // 正数负数的标记
  let sign = '';
  if (!flag) return param;
  // 是负数，则先去除前面的负号
  if (strParam.startsWith('-')) {
    strParam = strParam.replace('-', '');
    sign = '-';
  }
  // 指数符号 true: 正，false: 负
  let sysbol = true;
  if (/e-/.test(strParam)) {
    sysbol = false;
  }
  // 指数
  let index = Number(strParam.match(/\d+$/)[0]);
  // 基数
  // eslint-disable-next-line no-useless-escape
  let basis = strParam.match(/^[\d\.]+/)[0].replace(/\./, '');

  if (sysbol) {
    return sign + basis.padEnd(index + 1, 0);
  } else {
    return sign + basis.padStart(index + basis.length, 0).replace(/^0/, '0.');
  }
}
// 语言和货币的转换，用于计算汇率
export const langToCoinName = {
  cn: 'CNY',
  en: 'USD',
  jp: 'JPY',
  kr: 'USD',
  vn: 'USD',
  ru: 'RUB',
  'zh-TW': 'HKD',
  tr: 'USD',
  es: 'USD',
};

// 货币简称和汇率的转换
export const coinNameToRate = {
  CNY: 0.138,
  USD: 1.0,
  HKD: 0.1284,
  JPY: 0.006471,
  RUB: 0.01,
  TRY: 0.02889,
  KRW: 0.0007178,
  VND: 0.000039,
  BRL: 0.1739,
  EUR: 1.05786,
};

// lang转换为符号金额符号，默认为$
export const langToFiat = (locale) => {
  const fiatMap = new Map([
    ['cn', '¥'],
    ['jp', '¥'],
    ['ru', '₽'],
    ['zh-TW', 'HK$'],
  ]);
  return fiatMap.get(locale) || '$';
};

// 获取当前语言的汇率
export function getExchangeRate(locale, store) {
  return store.state.exchangeRate[langToCoinName[locale] || 'USD'];
}

/**
 * 根据美元转换为当前语言的金额
 * @param {Object} opts 配置项
 * @param {number} opt.amount 美元金额
 * @param {Object} opt.store store，如果传了store就从传入参数里拿，如果没传会去window中找，所以服务端渲染时务必传store
 * @param {string} opt.locale 指定语言，如en,cn等，优先级最高，若传了locale，就取locale，没有传取store
 * @param {boolean} opt.needUnit 是否需要单位，默认是需要的
 * @author inm
 * @returns 转换后的金额，默认是字符串类型，因为有可能带上单位符号
 */
export function convertAmount({ amount, store, needUnit = true, locale }) {
  // @TODO 临时的逻辑判断
  if (!store) return 0;

  const currLocale = locale || store.state.locale;
  // 这里更新了计算方式，原来是金额 * 汇率，现在是金额 / 汇率，因为汇率系统是1法币对应多少个美元
  const formatPrice = (amount / getExchangeRate(currLocale, store)).toFixed(2);
  return needUnit ? `${langToFiat(currLocale)} ${formatPrice}` : `${formatPrice}`;
}

/**
 * 转换币种价格精度，大于2，保持不变，小于2，增加0补位
 */
export function convertCoinMoneyAmount(amount) {
  const amountStr = +amount + '';
  if (~amountStr.indexOf('.') && amountStr.split('.')[1].length > 2) {
    return +amount;
  }

  return (+amount).toFixed(2);
}

/**
 * 验证是否登录
 * 若已经登录，返回resolve
 * 若未登录，stopRedirect为false时自跳转至登录页，stopRedirect为true时返回reject
 * @param {boolean} isStopRedirect 是否阻止自跳转登录页
 * @returns Promise
 * @author inm
 * @example hasLogin().then(() => { ... })
 * @example hasLogin(true).then(() => { ... }).catch(() => { ... })
 * @deprecated
 */
export function hasLogin(isStopRedirect = false, exLogin) {
  return new Promise((resolve, reject) => {
    
    if (isLoginedToken()) {
      resolve();
    } else {
      if (!isStopRedirect) {
        const { $route, $router, $store } = window.$nuxt;
        gotoLogin($router, $route, $store.state.locale, $route.query, undefined, exLogin);
      } else {
        reject();
      }
    }
  });
}

/**
 * hasLogin健壮版，用于支持app内跳转原生登录
 * @param {*} options
 * @param options.vueInstance vue实例
 * @param options.updateUserInfo  登录后更新用户信息
 * @param options.afterLoginHandle  登录后执行回调
 * @param options.exLogin 未登录跳转的登录路由名称
 * @returns
 */
export function nftHasLogin(options = {}) {
  return new Promise((resolve, reject) => {
    if (isLoginedToken()) {
      resolve();
    } else {
      if (!options.isStopRedirect) {
        if (!!window.jsBridge && window.jsBridge?.toLogin) {
          window.jsBridge.toLogin((params) => {
            console.log('nftHasLogin > window.jsBridge.toLogin', params);
            // 健壮代码，ios的JSON解析不合法
            // 以后可以移除
            params = params.replace(/(Optional\("(.*)"\)\))/, '$2');
            const paramsObj = JSON.parse(params);
            if (paramsObj?.success) {
              if (options.vueInstance) {
                setAppLoginInfo(options.store, paramsObj);
                if (options.updateUserInfo) {
                  options.store?.dispatch('account/getUserSecInfo');
                }
              }
              if (options.afterLoginHandle) {
                options.afterLoginHandle();
              }
            }
          });
        } else {
          gotoLogin(
            options.router,
            options.route,
            options.store.state.locale,
            options.route.query,
            undefined,
            options.exLogin
          );
        }
      } else {
        reject();
      }
    }
  });
}

// 根据域名添加图片url前缀
export const prefixUrlImg = function (imgUrl) {
  const priUrlMap = {
    dev: 'https://www.bitmart-dev.com',
    testing: 'https://www.bitmartgcp-test.com',
    production: 'https://img.bitmart.com',
  };
  const domain_env = import.meta.env.VITE_DOMAIN_ENV;
  if (!imgUrl || !domain_env) {
    return '';
  }
  if (imgUrl.startsWith('http')) {
    return imgUrl;
  }
  //const IMG_PREFIX = /^\/static-file/;
  return `${priUrlMap[domain_env]}${imgUrl}`;
};
export function firebaseLogEvent(name, eventData) {
  if (process?.env?.debug !== 'true' && process?.client) {
    try {
      const analytics = getAnalytics();
      logEvent(analytics, name, eventData);
    } catch (e) {
      console.log(e);
    }
  }
}

//设置用户相关信息
export function setAppLoginInfo(store, resData) {
  // TODO 3619
  console.log('setAppLoginInfo', store, resData);
  store.commit('SET_USER', resData.loginName);
  // store.commit('SET_TOKEN', resData.accessToken);
  store.commit('SET_SALT', resData.accessSalt);

  setLoginInfoInApp(resData);
}

export async function getStaticNetInfo(url, config) {
  return new Promise(function (resolve, reject) {
    const img = new Image();
    const startAt = Date.now();
    const tid = setTimeout(function () {
      reject({ errorType: 'timeout' });
    }, config.timeout);

    img.onerror = function (e) {
      clearTimeout(tid);
      reject({ errorType: 'error', timeCount: Date.now() - startAt });
    };
    img.onload = function () {
      clearTimeout(tid);
      resolve({ timeCount: Date.now() - startAt });
    };
    img.src = url;
  });
}

export function getAPIJsonpNetInfo(url, config) {
  return new Promise(function (resolve, reject) {
    const scriptEle = document.createElement('script');
    const startAt = Date.now();
    const tid = setTimeout(() => {
      reject({ errorType: 'timeout' });
    }, config.timeout);

    scriptEle.onload = function () {
      clearTimeout(tid);
      resolve({ timeCount: Date.now() - startAt });
      document.body.removeChild(scriptEle);
    };
    scriptEle.onerror = function (e) {
      clearTimeout(tid);
      reject({ errorType: 'error', timeCount: Date.now() - startAt });
      document.body.removeChild(scriptEle);
    };

    scriptEle.src = url;

    document.body.appendChild(scriptEle);
  });
}

// 切换语言
export function switchLanguage(lang, $route, $router) {
  const cookieOptions = {
    httpOnly: false,
    secure: import.meta.env.VITE_DEBUG === 'true' ? false : true,
    sameSite: 'Lax',
  };

  const webDomain = breakDownHostUrl(location.host);

  if (webDomain.indexOf('localhost') === -1) {
    Object.assign(cookieOptions, {
      domain: `.${webDomain}`,
    });
  }

  Cookies.set('golang', lang, cookieOptions);

  localStorage.setItem('golang', lang);

  const { name, query, params } = $route;
  $router.push({
    // 可能是健壮写法，暂留
    // @TODO 语种的切换逻辑是否要变更
    name: name === 'index' || name === 'index-lang' ? 'index-lang' : name,
    query,
    params: {
      ...params,
      lang,
    },
  });
}

export function unScroll() {
  document.body.style['overflow-y'] = 'hidden';
  //计算滚动条宽度 (滚动条的宽度不是都为17px的，算一下当前的比较精确)
  const outer = document.createElement('div');
  const inner = document.createElement('div');
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  document.body.removeChild(outer);

  document.body.style['padding-right'] = `${scrollbarWidth}px`;
}

//停止禁用滚动条
export function removeUnScroll() {
  document.body.style['overflow-y'] = 'auto';
  document.body.style['padding-right'] = '0px';
}

// 增加媒体查询监听事件
export function addMediaQueryEventListener(minWidth, listerner) {
  if (!minWidth) return;

  const MAP = {
    sm: '480px',
    md: '640px',
    lg: '960px',
    xl: '1120px',
    '2xl': '1280px',
    '3xl': '1440px',
    '4xl': '1680px',
    '5xl': '1920px',
  };

  console.log('MAP[minWidth]', MAP[minWidth]);
  const mqle = window.matchMedia(`(min-width: ${MAP[minWidth]})`);
  listerner && mqle.addListener(listerner);

  return mqle;
}

/**
 * app内设置用户登录信息
 * @param {Object} opt
 * @param {number} opt.ms 轮询定时器间隔，默认2000毫秒
 * @param {number} opt.fetchDelay 请求延迟时间，默认5000毫秒
 * @returns
 */
export function setUserInfoInApp(isApp, store, opt = { ms: 2000, fetchDelay: 5000 }) {
  const sint = setInterval(() => {
    const userName = Cookies.get('userName');
    if (userName && userName !== 'undefined') {
      store?.commit('SET_USER', Cookies.get('userName'));
      clearTimeout(sint);
    }
  }, opt.ms);

  if (isApp) {
    setTimeout(() => {
      store?.dispatch('account/getUserSecInfo');
    }, opt.fetchDelay);
  } else {
    store?.dispatch('account/getUserSecInfo');
  }
}
// bitmart其他网址重定向，主要用于动态链接拼接
export function dealZendeskUrl(zendeskUrl) {
  let result = zendeskUrl;
  const oriArr = ['https://support.bitmart.com', 'https://support.bmx.fund'];
  oriArr.forEach((url) => {
    if (zendeskUrl.indexOf(url) >= 0) {
      result = zendeskUrl.replace(url, 'https://www.bitmart.com/html/user_zendesk_sso?redirect=');
    }
  });
  return result;
}

// 数值进行千分位分隔
// return String
export function numbroUtil(val, format = '', upperCase) {
  if (_isNil(val)) return val;
  if (Number.isNaN(Number(val))) return val;

  val = scientificNumber(val);

  // 注意，js中带小数的数值，只能取到Number.MAX_SAFE_INTEGER的最大长度，所以如果一个数值，整数位和小数位都过大时，则计算会不精确
  // 因此后端返回的值必须是一个字符串，然后前端再参与处理
  // 如果值小于1000的值不进行处理
  if (Number(val) < 1000) return String(val);
  // 假如存在格式化参数，则直接通过numbro处理
  if (format && upperCase) {
    return numbro(val).format(format).toUpperCase();
  } else if (format) {
    return numbro(val).format(format);
  }

  // 先将数值分成两部分，取得最终值后再做一次拼接
  const splited = String(val).split('.');

  const integer = String(numbro(splited[0]).format(format));
  const decimal = splited[1] ? '.' + splited[1] : '';
  return integer + decimal;
}

export function numbroSeparated(val, precision) {
  const format = {
    thousandSeparated: true,
  };
  if (precision || precision === 0) {
    format.mantissa = Number(precision);
  }
  return numbroUtil(val, format);
}

/**
 * 金额精度处理,0返回0.00，否则去除末尾无意义的0
 *  */
// 针对数字，保留多少位小数，千分位格式化，+、-符号处理
export const numberFormat = (val, format = {}) => {
  // null，undefined直接返回
  if (_isNil(val)) return '0.00';
  // 非纯数字直接返回，比如已经包含有,--等
  if (Number.isNaN(Number(val))) return val;
  // 值为0时，且没有规定小数位数时，默认返回0.00
  if (Number(val) === 0 && format?.mantissa === undefined) {
    return '0.00';
  }
  // 科学计数法转为String
  val = scientificNumber(val);
  // 先将数值分成两部分，取得最终值后再做一次拼接
  const splitArr = String(val).split('.');
  let integer = splitArr[0];
  let decimal = splitArr.length > 1 ? splitArr[1] : '';
  // 去除小数位无用的0
  decimal = decimal.replace(/0+?$/, '');
  // 千分位处理
  if (format?.thousandSeparated) {
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  // 小数点后面保留多少位处理
  if (format?.mantissa) {
    // 去除无用的0
    if (decimal.length < format.mantissa) {
      let arr = new Array(format.mantissa - decimal.length).fill('0');
      decimal = decimal + arr.join('');
    } else if (decimal.length > format.mantissa) {
      decimal = decimal.slice(0, format.mantissa);
    }
  }
  // 正负号处理
  if (format?.forceSign) {
    if (!integer.startsWith('-') && !integer.startsWith('+')) {
      integer = '+' + integer;
    }
  }
  return decimal ? integer + '.' + decimal : integer;
};

// 限制精度，保留指定位数
// return String
export function limitPrecision(val, limit = 8) {
  if (Number.isNaN(Number(val))) return val;

  val = scientificNumber(val);

  const reg = limit === 0 ? new RegExp(`([^.]*)\\.?.*`) : new RegExp(`(\\..{0,${limit}}).*`);

  // 数值应该永远返回String
  // 清除掉末尾的连续0
  return String(val)
    .replace(reg, '$1')
    .replace(/(\.)(\d*?)(0+)$/, (matched, $1, $2, $3) => {
      if ($2.length === 0) {
        return '';
      } else {
        return $1 + $2;
      }
    });
}
// 估值优化，同时可以进千分位处理
// 测试数据
// const x=[
//   '等于0测试',
//   '0','0.00','0.000','0.0000',
//   '小于0.000001测试',
//   '0.000002','0.00000022','0.00000055','0.00000025','0.00000052',
//   '小于1测试',
//   '0.00','0.22','0.55','0.25','0.52','0.000','0.022','0.055','0.025','0.052','0.0000','0.0022','0.0055','0.0025','0.0052','0.3600','0.3622','0.3655','0.3625','0.3652',
//   '0.900','0.922','0.955','0.925','0.952','0.9000','0.9022','0.9055','0.9025','0.9052','0.90000','0.90022','0.90055','0.90025','0.90052','0.93600','0.93622','0.93655','0.93625','0.93652',
//   '0.900000','0.900022','0.900055','0.900025','0.900052','0.9000000','0.9000022','0.9000055','0.9000025','0.9000052','0.90000000','0.90000022','0.90000055','0.90000025','0.90000052','0.90003600','0.90003622','0.90003655','0.90003625','0.90003652',
//   '0.0900','0.0922','0.0955','0.0925','0.0952','0.09000','0.09022','0.09055','0.09025','0.09052','0.090000','0.090022','0.090055','0.090025','0.090052','0.093600','0.093622','0.093655','0.093625','0.093652',
//   '0.00900','0.00922','0.00955','0.00925','0.00952','0.009000','0.009022','0.009055','0.009025','0.009052','0.0090000','0.0090022','0.0090055','0.0090025','0.0090052','0.0093600','0.0093622','0.0093655','0.0093625','0.0093652',
//   '大于1测试',
//   '9','9.00','9.22','9.55','9.25','9.52','9.000','9.022','9.055','9.025','9.052','9.0000','9.0022','9.0055','9.0025','9.0052','9.3600','9.3622','9.3655','9.3625','9.3652',
//   '9000','9000.00','9000.22','9000.55','9000.25','9000.52','9000.000','9000.022','9000.055','9000.025','9000.052','9000.0000','9000.0022','9000.0055','9000.0025','9000.0052','9000.3600','9000.3622','9000.3655','9000.3625','9000.3652',
//   '9000000','9000000.00','9000000.22','9000000.55','9000000.25','9000000.52','9000000.000','9000000.022','9000000.055','9000000.025','9000000.052','9000000.0000','9000000.0022','9000000.0055','9000000.0025','9000000.0052','9000000.3600','9000000.3622','9000000.3655','9000000.3625','9000000.3652',
//
// ]
//
// x.forEach((item)=>{
//   console.log('原值=>',item,'结果=>',this.$valuation(item,true))
// })
// 估值优化
// return String
export function valuation(val, isThousand = false, format = '', upperCase) {
  if (_isNil(val)) return val;
  if (Number.isNaN(Number(val))) return val;

  if (Number(val) === 0) {
    return '0';
  } else if (Number(val) < 0.000001) {
    return '< 0.000001';
  } else if (Number(val) < 1) {
    // 先判断是否大于1
    // 先判断精度位数
    const matched = String(val).match(/(\d*)\.(\d{1,6})(\d?)\d*/);

    if (matched) {
      const x = matched[2];
      const y = matched[3] || 0;

      const decimalLen = x.length;
      const decimal = Math.round(Number(x + '.' + y));
      return '0.' + String(decimal).padStart(decimalLen, '0');
    } else {
      return String(val);
    }
  } else {
    const matched = String(val).match(/(\d*)\.(\d{1,2})(\d?)\d*/);

    let newVal = val;

    if (matched) {
      const integer = matched[1];
      const x = matched[2];
      const y = matched[3] || 0;

      const decimalLen = x.length;
      const decimal = Math.round(Number(x + '.' + y));
      newVal = Number(integer + '.' + String(decimal).padStart(decimalLen, '0'));
    }

    if (isThousand) {
      return numbroUtil(newVal, format, upperCase);
    } else {
      return String(newVal);
    }
  }
}

/**
 * 获取精度
 * @param {*} string
 * @returns
 */
export const getFixedNumber = (string) => {
  if (string) {
    const arr = string.split('.')[1];
    return arr ? arr.length : 0;
  }
  return 0;
};

/**
 * 清除一个数组中值为空的项
 * @param {Array} array
 * @return 处理后的数组
 */
export const cleanEmptyInArray = function (array) {
  let [...newArray] = array;
  const count = newArray.length;
  for (let i = count - 1; i >= 0; i--) {
    if (newArray[i] === '' || newArray[i] === null || newArray[i] === undefined) {
      newArray.splice(i, 1);
    }
  }
  return newArray;
};

// 动态注入全局样式
export const insertGlobalCss = (text) => {
  let style = document.createElement('style'); //创建一个style元素
  let head = document.head || document.getElementsByTagName('head')[0]; //获取head元素
  style.type = 'text/css';
  let cssText = text;
  let textNode = document.createTextNode(cssText);
  style.appendChild(textNode);
  head.appendChild(style);
  return () => {
    head.removeChild(style);
  };
};

/**
 * @params startTime 时间戳
 * @returns 列表
 */
export const setXchange = (startTime, endTime) => {
  let array = [];
  if (startTime && endTime) {
    const start = moment(startTime);
    const end = moment(endTime);
    const days = end.diff(start, 'days') - 1;
    array = [start.valueOf()];
    new Array(days).fill(0).forEach((_, i) => {
      array.push(start.add(1, 'days').valueOf());
    });
  }
  return array;
};

/**
 * 从小数后非0数字开始保留指定位数
 * @param {*} num 数字
 * @param {*} fixNumber 位数
 */
export const fixDecimalStartByUnZeroPosition = (num, fixNumber) => {
  const numStr = scientificNumber(num + '');

  if (!fixNumber) {
    return numStr;
  }

  // 没有小数补位返回
  if (numStr.indexOf('.') < 0) {
    return numStr + '.' + new Array(fixNumber).fill(0).join('');
  }

  // 小数位个数小于fixNumber, 补0后返回
  const splitArr = numStr.split('.');
  const decimalPart = splitArr[1];
  if (decimalPart.length < fixNumber) {
    return numStr + new Array(fixNumber - decimalPart.length).fill(0).join('');
  }

  const reg = /^\d+\.0*(\d{2,})?$/;
  const numberStartByUnZero = numStr.match(reg)[1];
  if (numberStartByUnZero) {
    return numStr.replace(numberStartByUnZero, numberStartByUnZero.slice(0, fixNumber));
  }
  return splitArr[0] + '.' + new Array(fixNumber).fill(0).join('');
};

export const dealHtmlInner = (htmlContent, dealP = true) => {
  if (!htmlContent) {
    return htmlContent;
  }
  let newContent = htmlContent;
  newContent = xss(newContent, {
    css: false,
    whiteList: {
      br: [],
      em: ['style'],
      u: ['style'],
      a: ['href', 'target', 'style', 'rel'],
      p: ['style'],
      span: ['style'],
      strong: ['style'],
    },
  });

  if (dealP) {
    newContent = newContent.replace(/<p><\/p>/g, '<p style="line-height:10px;"> </p>');
  }
  return newContent;
};

// 字符串占位符format {0} {1}, ['p1', 'p2']
export const stringFormatPlaceholder = (content, arr = []) => {
  if (!content) {
    return content;
  }
  let decodeContent = decodeURI(content);
  for (let i = 0; i < arr.length; i++) {
    decodeContent = decodeContent.replace(new RegExp('\\{' + i + '\\}', 'g'), arr[i]);
  }
  return decodeContent;
};

export const wait = (time) => {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};

// 转换路由中语言值为新的标准值
export const transRouteLang = (lang, store) => {
  return OLD_LOCALES_OBJ_REVERSE[lang] || lang || 'en-US';
};

export const compressImage = (file, quality = 0.8) =>
  new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      // 图片原始尺寸
      const originWidth = img.width;
      const originHeight = img.height;

      // 最大尺寸限制
      // 目标尺寸
      const targetWidth = Math.round(originWidth * quality);
      const targetHeight = Math.round(originHeight * quality);

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // canvas对图片进行缩放
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      // 清除画布
      context.clearRect(0, 0, targetWidth, targetHeight);
      // 图片压缩
      context.drawImage(img, 0, 0, targetWidth, targetHeight);
      // canvas转为blob并上传
      canvas.toBlob(function (blob) {
        const f = new window.File([blob], file.name, { type: file.type });
        resolve(f);
      }, file.type || 'image/png');
    };
  });

/**
 * 删除字符串数字 小数点后面多余的 0
 * @param {*} nstring
 * @returns
 */
export const delZero = (nstring) => {
  // 可能是包含科学记数法的string
  const newString = scientificNumber(nstring);
  const spBg = newString.toString().split('.');
  if (spBg.length === 2) {
    let delFlag = true;
    spBg[1] = spBg[1]
      .split('')
      .reverse()
      .map((charNum) => {
        if (delFlag && charNum === '0') {
          return '';
        } else {
          delFlag = false;
          return charNum;
        }
      })
      .reverse()
      .join('');
    if (spBg[1].length === 0) {
      return spBg[0];
    }
    return spBg.join('.');
  }
  return newString;
};

export const sleep = function (duration = 0) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
};

export const checkIsApp = () => {
  if (!process.client) {
    return false;
  }
  const bitMartAppPattern = /BitMart/;
  return !!window.jsBridge && bitMartAppPattern.test(navigator.userAgent);
};

export const hideAppNavigationBar = () => {
  window.jsBridge?.invoke('navigationBarStatus', { status: 0 });
};

export const scrollTo = (
  element,
  to,
  duration,
  cb = () => { }
) => {
  if (!element) {
    return;
  }
  let start = element.scrollTop;
  let change = to - start;
  let currentTime = 0;
  let increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    let val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      cb();
    }
  };

  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  animateScroll();
};
export const StatusEnum = {
  WarmUp: 0,
  Progress: 1,
  Ended: 2,
};
export const StatusMap = {
  [StatusEnum.WarmUp]: {
    color: '#F4B81E',
    text: 'vip.events-center.warmup',
    after: 'vip.events-center.start_in'
  },
  [StatusEnum.Progress]: {
    color: '#13C2C2',
    text: 'vip.events-center.progress',
    after: 'vip.events-center.ends_in'
  },
  [StatusEnum.Ended]: {
    color: '#9C9FA5',
    text: 'vip.events-center.ended',
  },
};

export const CampaignsStatusMap = {
  [StatusEnum.WarmUp]: {
    color: '#01E0E0',
    text: 'vip-portal.vip-campaigns.warmup',
    after: 'vip-portal.vip-campaigns.start_in'
  },
  [StatusEnum.Progress]: {
    color: '#13C2C2',
    text: 'vip-portal.vip-campaigns.progress',
    after: 'vip-portal.vip-campaigns.ends_in'
  },
  [StatusEnum.Ended]: {
    color: '#9C9FA5',
    text: 'vip-portal.vip-campaigns.ended',
  },
};

export const isMobile = () => {
  if (!process.client) {
    return false;
  };
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};